import {
  ClindxTableFilterType,
  DATA_CREATION_DATE,
  DOB_FORMAT,
  HEAD_CREATION_DATE,
  HEAD_EXSHORT,
  HEAD_MEDIUM,
  HEAD_SELECT,
  HEAD_SHORT,
  LAST_UPDATED_BY,
  LAST_UPDATED_ON,
  OVERFLOW_CONTROL,
  OVERFLOW_CONTROL_CONTENT_WRAP,
  PATIENT_NAME,
  REQUISITION_NUMBER_LABEL,
  TEXT_CENTER
} from './clindx-mat-table.shared';

export const RegisterLabelsColumnList = [
  {
    columnName: 'firstRequisition',
    columnDisplayValue: 'First Requisition',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '12%',
    type: ClindxTableFilterType.inputType,
    maxLength: 15,
    hasSort: false
  },
  {
    columnName: 'lastRequisition',
    columnDisplayValue: 'Last Requisition',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '12%',
    type: ClindxTableFilterType.inputType,
    maxLength: 15,
    hasSort: false
  },
  {
    columnName: 'format',
    columnDisplayValue: 'Format',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '10%',
    type: ClindxTableFilterType.inputType,
    maxLength: 15,
    hasSort: false
  },
  {
    columnName: 'accountName',
    columnDisplayValue: 'Account',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '18%',
    type: ClindxTableFilterType.inputType,
    maxLength: 60,
    hasSort: false
  },
  {
    columnName: 'numberOfLabels',
    columnDisplayValue: 'Number Of Labels',
    classThName: HEAD_MEDIUM,
    classTdName: TEXT_CENTER,
    columnWidth: '12%',
    type: ClindxTableFilterType.inputType,
    maxLength: 5,
    hasSort: false
  },
  {
    columnName: 'createdByName',
    columnDisplayValue: 'Created By',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '12%',
    type: ClindxTableFilterType.inputType,
    maxLength: 50,
    hasSort: false
  },
  {
    columnName: 'createdOn',
    columnDisplayValue: 'Created On',
    classThName: HEAD_CREATION_DATE,
    classTdName: DATA_CREATION_DATE,
    columnWidth: '10%',
    type: ClindxTableFilterType.dateType
  },
  {
    columnName: 'edit1',
    columnDisplayValue: 'Actions',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    columnWidth: '11%',
    hasSort: false
  }
];

export const CommercialorderColumnList = [
    {
    columnName: 'isStandingOrder',
    columnDisplayValue: 'SO',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    columnWidth: '2%',
    hasSort: false
  },
  {
    columnName: 'requsitionNumber',
    columnDisplayValue: REQUISITION_NUMBER_LABEL,
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '130px'
  },
  {
    columnName: 'accessionId',
    columnDisplayValue: 'Accession ID',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '130px'
  },
  {
    columnName: 'patientName',
    columnDisplayValue: 'Patient',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '80px',
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2,
    dataAccessor: (row) => {
      return [row.patientLastName, row.patientFirstName, row.patientMI]
        .filter((val: string) => val?.toString().length).join(', ');
    }
  },
  {
    columnName: 'patientDOB',
    columnDisplayValue: 'DOB',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '60px',
    type: ClindxTableFilterType.dateWithValidationType,
    placeHolder: DOB_FORMAT,
  },
  {
    columnName: 'placedOn',
    columnDisplayValue: 'Placed On',
    classThName: HEAD_SHORT,
    classTdName: '',
    columnWidth: '100px',
    type: ClindxTableFilterType.dateRangeType,
  },
  {
    columnName: 'collectedOn',
    columnDisplayValue: 'Collection Date',
    classThName: HEAD_SHORT,
    classTdName: '',
    columnWidth: '100px',
    type: ClindxTableFilterType.dateRangeType,
  },
  {
    columnName: 'commercialTests',
    columnDisplayValue: 'Test(s)',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '90px',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 250,
  },
  {
    columnName: 'mainAccount',
    columnDisplayValue: 'Account',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '145px',
    dataAccessor: (row) => {
      return `${row.mainAccountName} (${row.mainAccountCode})`;
    }
  },
  {
    columnName: 'physicianName',
    columnDisplayValue: 'Physician',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '100px',
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2,
    dataAccessor: (row) => {
      return [row.physicianFirstName, row.physicianTitle, row.physicianLastName]
        .filter((val: string) => val?.toString().length).join(' ');
    }
  },
  {
    columnName: 'commercialOrderStatus',
    columnDisplayValue: 'Status',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '100px',
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Completed', value: 'Completed' },
      { name: 'Cancelled', value: 'Cancelled' },
      { name: 'Mobile Draw schedule pending', value:'Mobile Draw schedule pending'},      
      { name: 'Third Party Draw pending', value:'Third Party Draw pending'},
      { name: 'Sample collected', value:'Sample collected'},
      { name: 'Sample received at Lab', value:'Sample received at Lab'},
      { name: 'Order Placed', value:'Order Placed'},
      { name: 'Pending Release', value:'Pending Release'},
      { name: 'Pending Release (Final Order)', value:'Pending Release (Final Order)'},

    ],
  },
  {
    columnName: 'drawChoice',
    columnDisplayValue: 'Draw Choice',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    columnWidth: '15px',
    hasSort: true,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Scheduled in clinic', value: 'Scheduled in clinic' },
      { name: 'Transplant Genomics to schedule draw', value: 'Transplant Genomics to schedule draw' },
      { name: 'Third party draw - Kit request', value: 'Third party draw - Kit request'},
    ],
  },
  {
    columnName: 'commercialActions',
    columnDisplayValue: 'Actions',
    classThName: HEAD_SHORT,
    classTdName: '',
    columnWidth: '7px',
    hasSort: false
  }
];

export const SpecimenTypesColumnList = [
  {
    columnName: 'labSpecCode',
    columnDisplayValue: 'LabPort Specimen Code',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'buSpecCode',
    columnDisplayValue: 'BU Specimen Code',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'specShortName',
    columnDisplayValue: 'Specimen Short Name',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'specFullName',
    columnDisplayValue: 'Specimen Full name',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'updatedOnDate',
    columnDisplayValue: LAST_UPDATED_ON,
    classThName: HEAD_MEDIUM,
    classTdName: DATA_CREATION_DATE,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'lastUpdatedBy',
    columnDisplayValue: LAST_UPDATED_BY,
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_SHORT,
    classTdName: '',
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'InActive', value: 'InActive' }
    ]
  },
  {
    columnName: 'buName',
    columnDisplayValue: 'BU',
    classThName: HEAD_SHORT,
    classTdName: '',
    type: ClindxTableFilterType.inputType,
    maxLength: 250
  },
  {
    columnName: 'actions',
    columnDisplayValue: 'Actions',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    hasSort: false
  }
];

export const QuestionsTableColumnList = [
  {
    columnName: 'labPortQuestionCode',
    columnDisplayValue: 'LabPort Question Code',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    minLength: 2
  },
  {
    columnName: 'buQuestionCode',
    columnDisplayValue: 'BU Question Code',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    minLength: 2
  },
  {
    columnName: 'question',
    columnDisplayValue: 'Question',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2
  },
  {
    columnName: 'fieldType',
    columnDisplayValue: 'Field Type',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Integer', value: 'Integer' },
      { name: 'Float', value: 'Float' },
      { name: 'Text', value: 'Text' },
      { name: 'Enum', value: 'Enum' },
      { name: 'DateOnly', value: 'DateOnly' },
      { name: 'DateTime', value: 'DateTime' },
      { name: 'TimeOnly', value: 'TimeOnly' },
      { name: 'Formula', value: 'Formula' },
      { name: 'String', value: 'String' },
      { name: 'Date', value: 'Date' }
    ]
  },
  {
    columnName: 'lastUpdatedOn',
    columnDisplayValue: LAST_UPDATED_ON,
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'lastUpdatedBy',
    columnDisplayValue: LAST_UPDATED_BY,
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputTypeWithMinLength,
    minLength: 2
  },
  {
    columnName: 'isMandatory',
    columnDisplayValue: 'Mandatory',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Yes', value: 'Yes' },
      { name: 'No', value: 'No' }
    ],
    dataAccessor: (row) => {
      return (row.isMandatory) ? 'Yes' : 'No';
    }
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_SHORT,
    classTdName: '',
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'Inactive', value: 'InActive' }
    ]
  },
  {
    columnName: 'businessUnit',
    columnDisplayValue: 'BU',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2
  },
  {
    columnName: 'Actions',
    columnDisplayValue: 'Actions',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    hasSort: false
  }
];

export const UploadPatientTableColumnList = [
  {
    columnName: 'patientName',
    columnDisplayValue: PATIENT_NAME,
    classThName: HEAD_MEDIUM,
    classTdName: '',
    hasSort: true
  },
  {
    columnName: 'dob',
    columnDisplayValue: 'DOB',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    hasSort: true
  },
  {
    columnName: 'gender',
    columnDisplayValue: 'Gender',
    classThName: HEAD_SHORT,
    classTdName: '',
    hasSort: true
  },
  {
    columnName: 'phone',
    columnDisplayValue: 'Phone',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    hasSort: true
  },
  {
    columnName: 'email',
    columnDisplayValue: 'Email',
    classThName: 'head-long',
    classTdName: 'email-column',
    hasSort: true
  },
  {
    columnName: 'addressLine1',
    columnDisplayValue: 'Address',
    classThName: 'head-long',
    classTdName: '',
    hasSort: true
  }
];

export const PatientListTableColumnList = [
  {
    columnName: 'patientId',
    columnDisplayValue: 'Patient ID',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 50,
    minLength: 2
  },
  {
    columnName: 'patientName',
    columnDisplayValue: PATIENT_NAME,
    classThName: HEAD_MEDIUM,
    classTdName: '',
    dataAccessor: (row) => {
      return [row.patientLastName, row.patientFirstName, row.patientMI]
        .filter((val: string) => val?.toString().length).join(', ');
    },
  },
  {
    columnName: 'dob',
    columnDisplayValue: 'DOB',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    type: ClindxTableFilterType.dateWithValidationType,
    placeHolder: DOB_FORMAT
  },
  {
    columnName: 'mrn',
    columnDisplayValue: 'MRN',
    classThName: HEAD_MEDIUM,
    classTdName: 'overflow-control column-control',
    type: ClindxTableFilterType.inputTypeWithMinLength,
    minLength: 2,
    maxLength: 50
  },
  {
    columnName: 'gender',
    columnDisplayValue: 'Gender',
    classThName: HEAD_SHORT,
    classTdName: '',
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Male', value: 'Male' },
      { name: 'Female', value: 'Female' },
      { name: 'Ambiguous', value: 'Ambiguous' },
      { name: 'Unknown', value: 'Unknown' },
    ]
  },
  {
    columnName: 'phone',
    columnDisplayValue: 'Phone',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 10,
    minLength: 2
  },
  {
    columnName: 'email',
    columnDisplayValue: 'Email',
    classThName: 'head-long',
    classTdName: 'overflow-control email-column',
    type: ClindxTableFilterType.inputTypeWithMinLength,
    maxLength: 250,
    minLength: 2
  },
  {
    columnName: 'linkedAccountsInfo',
    columnDisplayValue: 'Linked Account(s)',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 100
  },
  {
    columnName: 'addressLine',
    columnDisplayValue: 'Address',
    classThName: 'head-long',
    classTdName: '',
    type: ClindxTableFilterType.inputType,
    maxLength: 250,
    dataAccessor: (row) => {
      return [row.addressLine1, row.addressLine2, row.city, row.state, row.zipCode]
        .filter((val: string) => val?.toString().length).join(',');
    }
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'Inactive', value: 'Inactive' }
    ]
  },
  {
    columnName: 'actionsForPatientList',
    columnDisplayValue: 'Actions',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    hasSort: false
  }
];

export const UploadPatientValidationResultTableColumnList = [
  {
    columnName: 'index',
    columnDisplayValue: 'Index',
    classThName: HEAD_MEDIUM,
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'patientName',
    columnDisplayValue: PATIENT_NAME,
    classThName: HEAD_MEDIUM,
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'message',
    columnDisplayValue: 'Message',
    classThName: HEAD_SHORT,
    classTdName: '',
    hasSort: false
  }
];

export const TestsColumnList = [
  {
    columnName: 'labPortTestCode',
    columnDisplayValue: 'LabPort Test/Panel Code',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2
  },
  {
    columnName: 'buTestCode',
    columnDisplayValue: 'BU Test/Panel Code',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2
  },
  {
    columnName: 'test',
    columnDisplayValue: 'Test/Panel Name',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL
  },
  {
    columnName: 'lastUpdatedOn',
    columnDisplayValue: LAST_UPDATED_ON,
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'lastUpdatedBy',
    columnDisplayValue: LAST_UPDATED_BY,
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'Inactive', value: 'InActive' }
    ]
  },
  {
    columnName: 'businessUnit',
    columnDisplayValue: 'BU',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    minLength: 2
  },
  {
    columnName: 'accounts',
    columnDisplayValue: 'Account(s)',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  },
  {
    columnName: 'isPanel',
    columnDisplayValue: 'Is Test/Panel',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Panel', value: 'Panel' },
      { name: 'Test', value: 'Test' }
    ]
  },
  {
    columnName: 'TestActions',
    columnDisplayValue: 'Actions',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  }
];

export const ManageProjectsColumnList = [
  {
    columnName: 'accessCode',
    columnDisplayValue: 'Access Code',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    maxLength: 100
  },
  {
    columnName: 'eventName',
    columnDisplayValue: 'Project Name',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL
  },
  {
    columnName: 'address',
    columnDisplayValue: 'Address',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'startDate',
    columnDisplayValue: 'Start Date',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.dateRangeType,
    maxLength: 50
  },
  {
    columnName: 'endDate',
    columnDisplayValue: 'End Date',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'accountName',
    columnDisplayValue: 'Account',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'testMap',
    columnDisplayValue: 'Test',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'Inactive', value: 'Inactive' }
    ]
  },
  {
    columnName: 'registrationLink',
    columnDisplayValue: 'Project Registration Link',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  },
  {
    columnName: 'projectActions',
    columnDisplayValue: 'Actions',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false
  }
];

export const AssignPatientsGridColumnList = [
  {
    columnName: 'select',
    columnDisplayValue: 'Select',
    classThName: HEAD_SELECT,
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'name',
    columnDisplayValue: 'Name',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    dataAccessor: (row) => {
      return [row.lastName, row.firstName, row.patientMI]
        .filter((val: string) => val?.toString().length).join(' ');
    },
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'email',
    columnDisplayValue: 'Email',
    classThName: HEAD_SHORT,
    classTdName: 'overflow-control email-column',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'phone',
    columnDisplayValue: 'Phone',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.numberType,
    maxLength: 10
  }
];